import Box from '@mui/material/Box'
import brushfireLogo from '@/features/auth/assets/login/brushfire-logo.png'
import { surveyEntryLogoImgSx, surveyEntryLogoWrapSx } from '../styles/surveyEntryStyles'

/** Figma 5074-14074 — Brushfire logo at top center of survey entry card (5074-14035). */
export function SurveyEntryLogo() {
  return (
    <Box sx={surveyEntryLogoWrapSx} data-survey-entry-logo-wrap>
      <Box
        component="img"
        src={brushfireLogo}
        alt="Brushfire"
        sx={surveyEntryLogoImgSx}
        data-testid="survey-entry-logo"
      />
    </Box>
  )
}
